import { Tab } from "@headlessui/react";
import { useEffect, useState } from "react";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";

const DataPanelWrapper = ({ isMounted, children, className = "" }) => {
  const [hidden, setHidden] = useState(false);
  const { activeTabWorldwide, activeTabCountries, activeTabRegions } = useSnapshot(context);

  useEffect(() => {
    if (isMounted()) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }, [activeTabWorldwide, activeTabRegions, activeTabCountries]);

  return (
    <Tab.Panel className={`transition relative duration-500 ease-out ${hidden ? "opacity-0 -translate-x-5" : ""} ${className}`}>
      {children}
    </Tab.Panel>
  );
};

export default DataPanelWrapper;
